<template>
  <div class="keyte-page">
    <div class="ipt-top">
      <div>
        <el-button type="primary" size="small" @click="addMateria">新增</el-button>
      </div>
      <div style="width:400px;display:flex;justify-content:flex-end;">
        <div class="key-top">
          <el-input placeholder="请输入材料名称" v-model.trim="word">
            <el-button slot="append" color="primary" @click="serach">查询</el-button>
          </el-input>
        </div>
        <el-button @click="resetform">重置</el-button>
      </div>
    </div>
    <el-table
      v-loading="listLoading"
      stripe
      style="width:100%"
      border
      :data="tableData1"
      height="650"
    >
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="projectName" label="项目名称"></el-table-column>
      <el-table-column label="材料类型">
        <template slot-scope="scope">
          <span v-if="scope.row.groupType === 1">审核材料</span>
          <span v-if="scope.row.groupType === 2">物流材料</span>
        </template>
      </el-table-column>
      <el-table-column prop="item" label="材料名称"></el-table-column>
      <el-table-column prop="value" label="材料关键字"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="watch(scope.row,true)">查看</el-button>
          <el-button type="text" size="small" @click="watch(scope.row,false)">编辑</el-button>
          <el-button type="text" size="small" @click="DeleteMatira(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog title="
材料关键字" :visible.sync="dialogFormVisible">
      <el-form
        label-width="100px"
        label-position="left"
        class="key-dialog"
        :model="seeData"
        :rules="rules"
        ref="teruleform"
      >
        <el-form-item label="材料类别" prop="groupType">
          <el-select v-model="seeData.groupType" :disabled="!isAdd">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item,index) in type"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材料名称" prop="item">
          <el-input v-model.trim="seeData.item" :disabled="!isAdd"></el-input>
        </el-form-item>
        <el-form-item label="关键字" prop="value">
          <el-input
            type="textarea"
            v-model="seeData.value"
            placeholder="
关键字请用逗号，隔开"
            :disabled="iswatch"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitkey">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  configpage,
  configupdate,
  configadd,
  configdel
} from "@/api/Materialkey";
export default {
  data() {
    return {
      tableData1: [],
      listLoading: false,
      projectName: null,
      word: null,
      dialogFormVisible: false,
      iswatch: false,
      isAdd: false,
      seeData: {
        groupType: "",
        item: "",
        value: ""
      },
      rules: {
        groupType: [
          { required: true, message: "请选择材料类别", trigger: "change" }
        ],
        item: [{ required: true, message: "请输入材料名称", trigger: "blur" }],
        value: [{ required: true, message: "请填写关键字", trigger: "blur" }]
      },
      addList: [],
      fileList: [],
      token: this.$store.getters.token,
      dialogTableVisible: false,
      type: [{ label: "审核材料", value: 1 }, { label: "物流材料", value: 2 }]
    };
  },
  created() {
    this.projectName = this.$route.query.id * 1;
    this.initData();
  },
  methods: {
    resetform() {
      this.word = null;
      this.$router.replace({
        query: { id: this.projectName }
      });
      this.initData();
    },
    initData() {
      this.listLoading = true;
      const info = {
        pageIndex: 1,
        pageSize: 10000,
        projectId: this.projectName
      };
      configpage(info).then(res => {
        this.listLoading = false;
        this.tableData1 = res.data.records;
      });
    },
    watch(row, bol) {
      this.iswatch = bol;
      this.isAdd = false;
      this.seeData = row;
      this.dialogFormVisible = true;
    },
    DeleteMatira(row) {
      this.$confirm("此操作将永久删除该材料关键字, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          configdel(row.id).then(res => {
            this.$router.replace({ query: this.projectName });
            this.word = "";
            this.initData();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          });
        })
        .catch(() => {});
    },
    addMateria() {
      this.isAdd = true;
      this.seeData.groupType = null;
      this.seeData.item = "";
      this.seeData.value = "";
      console.log("seeData", this.seeData);
      this.dialogFormVisible = true;
    },
    serach() {
      if (this.word) {
        var infos = {
          pageIndex: 1,
          pageSize: 10000,
          item: this.word,
          projectId: this.projectName
        };
        configpage(infos).then(res => {
          this.listLoading = false;
          this.tableData1 = res.data.records;
        });
        this.$router.replace({
          query: { word: this.word, id: this.projectName }
        });
      } else {
        const info = {
          pageIndex: 1,
          pageSize: 10000,
          projectId: this.projectName
        };
        configpage(info).then(res => {
          this.listLoading = false;
          this.tableData1 = res.data.records;
        });
        this.$router.replace({ query: { id: this.projectName } });
      }
    },

    submitkey() {
      if (this.iswatch) {
        this.dialogFormVisible = false;
        return false;
      }
      this.$refs["teruleform"].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            var str = {
              groupType: this.seeData.groupType,
              item: this.seeData.item,
              keyword: this.seeData.value,
              projectId: this.projectName
            };
            configadd(str)
              .then(res => {
                this.$router.replace({ query: { id: this.projectName } });
                this.word = "";
                this.initData();
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.dialogFormVisible = false;
              })
              .catch(err => {
                this.dialogFormVisible = false;
                this.$message.error(err.message);
              });
          } else {
            const info = {
              id: this.seeData.id,
              keyword: this.seeData.value
            };
            configupdate(info).then(res => {
              this.$router.replace({ query: { id: this.projectName } });
              this.word = "";
              this.initData();
              this.$message({
                message: res.message,
                type: "success"
              });
              this.dialogFormVisible = false;
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.keyte-page {
  .ipt-top {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    .key-top {
      margin-right: 20px;
      max-width: 300px;
      min-width: 200px;
    }
  }
  .grid-content {
    display: flex;
    p {
      &:nth-child(1) {
        width: 30%;
      }
    }
  }
  .btn-all {
    margin-left: 10px;
    display: inline-block;
    width: 50px;
    button {
      margin: 0px;
    }
  }
  .foot-btn {
    margin-top: 15px;
  }
}
</style>
<style lang="scss">
.keyte-page {
  .ipt-top {
    .el-input-group__append {
      background-color: rgb(24, 144, 255);
      color: #fff;
    }
  }
  .el-dialog {
    width: 580px;
    height: 600px;
    overflow: auto;
    .key-dialog {
      label {
        font-weight: 400;
      }
      .el-textarea {
        width: 280px;
      }
    }
  }
  .importbtn {
    .el-input-group__append {
      position: relative;
      .el-upload-list {
        width: 430px;
        position: absolute;
        right: 72px;
        top: 0px;
        bottom: 0px;
        margin: auto 0;
        .el-upload-list__item {
          margin-top: 6px;
        }
      }
    }
  }
}
</style>